import { useEffect, useState } from 'react'
import {
  cycleFieldMode,
  getFieldMode,
  isFieldModeOverridden,
  subscribeFieldMode,
  type FieldMode,
} from '../lib/canvas-field-mode.js'

/**
 * Live canvas field mode plus the `Shift+F` cycle binding.
 * The badge only shows once a mode has been chosen explicitly.
 */
export function useFieldMode(): { mode: FieldMode; showBadge: boolean } {
  const [mode, setMode] = useState<FieldMode>(() => getFieldMode())
  const [showBadge, setShowBadge] = useState<boolean>(() => isFieldModeOverridden())

  useEffect(() => subscribeFieldMode(setMode), [])

  useEffect(() => {
    const onKeyDown = (event: KeyboardEvent) => {
      if (!event.shiftKey || event.metaKey || event.ctrlKey || event.altKey) return
      if (event.key !== 'F' && event.key !== 'f') return
      const target = event.target as HTMLElement | null
      if (target?.isContentEditable) return
      const tag = target?.tagName
      if (tag === 'INPUT' || tag === 'TEXTAREA' || tag === 'SELECT') return
      event.preventDefault()
      cycleFieldMode()
      setShowBadge(true)
    }
    window.addEventListener('keydown', onKeyDown)
    return () => window.removeEventListener('keydown', onKeyDown)
  }, [])

  return { mode, showBadge }
}
